// project import
import Routes from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //


const App = () => {


    return (
        <ThemeCustomization>
            <ScrollTop>
                <Routes />
                <ToastContainer position={toast.POSITION.TOP_CENTER} />
            </ScrollTop>
        </ThemeCustomization>
    )
};

export default App;
